<template>
    <div>
        <ui-table
            :columns="tableColumns"
            :data="contents"
            :select-column-menu="false"
            :loading="false"
            name="tableLaunchPaymentMethods"
            tr-component="launch/management/table-launch-payment-methods/subcategories-table.vue"
            not-found-text="Não foi possível encontrar nenhuma regra."
            not-found-icon="fa fa-file-contract"
        />

        <ui-modal-message
            name="launch-payment-method-subcategory-delete"
            service="launchDay"
            title="Deseja realmente excluir esta subcategoria?"
            text="Cuidado, esta ação não poderá ser desfeita."
            btn-type="danger"
            btn-text="Confirmar"
            icon="fal fa-trash-alt"
            color-circle="danger"
            icon-circle
        />
    </div>
</template>

<script>
	import { uiTable } from '@/components/ui'
	import { uiModalMessage } from '@/components/ui/modal'

	export default {
        name: 'ui-launch-subcategories-table',

		components: {
			uiTable,
			uiModalMessage
		},

		props: {
			contents: {
				type: Array,
				required: true
			}
		},

		data() {
			return {
				tableColumns: [
					{ title: 'Categoria' },
                    { title: 'Subcategoria' },
					{ title: '' }
				]
			}
		}
	}
</script>

<style>

</style>